import type { IClientPush } from '@/entities/client.entity';
import { cn } from '@/lib/utils';
import { BellIcon } from 'lucide-react';
import TimeAgo from 'react-timeago';
import russianStrings from 'react-timeago/lib/language-strings/ru';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';

const formatter = buildFormatter(russianStrings);

interface ClientPushCardProps {
	push: IClientPush;
	onCopy: (text: string) => void;
	className?: string;
}

export default function ClientPushCard({ push, onCopy, className }: ClientPushCardProps) {
	return (
		<div className={cn('rounded-lg border border-border bg-card p-2.5 shadow-sm border-l-[3px] border-l-chart-4', className)}>
			<div className='flex items-start gap-2'>
				<div className='flex size-7 shrink-0 items-center justify-center rounded-lg bg-chart-4/15 text-chart-4'>
					<BellIcon size={14} />
				</div>

				<div className='min-w-0 flex-1'>
					<div className='flex items-center justify-between gap-2'>
						<button
							type='button'
							className='text-sm font-semibold text-chart-4 hover:bg-accent rounded-xs px-0.5 cursor-pointer select-none truncate'
							onClick={() => onCopy(push.packageName)}
						>
							{push.packageName}
						</button>
						<span className='text-xs text-muted-foreground shrink-0'>
							<TimeAgo date={push.createdAt} formatter={formatter} />
						</span>
					</div>
				</div>
			</div>

			<button
				type='button'
				className='mt-1.5 block w-full text-left rounded-2xl rounded-tl-sm bg-muted/50 px-2.5 py-2 hover:bg-muted/70 cursor-pointer select-none'
				onClick={() => onCopy(`${push.title}\n${push.text}`)}
			>
				{push.title ? <p className='text-sm font-medium leading-snug'>{push.title}</p> : null}
				{push.text ? (
					<p className={cn('text-sm leading-relaxed text-muted-foreground', push.title && 'mt-1')}>{push.text}</p>
				) : null}
			</button>
		</div>
	);
}
